import React, { useState } from 'react';
import API from './Api'; 
import contactSideImage from '../assets/images/contactusimg.jpg'; 
import SubPageHeader from '../components/common/SubPageHeader';
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const Contact = () => {
  
  const [formData, setFormData] = useState({ name: '', email: '', remarks: '' });
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      
      const response = await API.post('contact-us/', formData);
      setStatus("We have received your message, we will contact you soon!");
      setFormData({ name: '', email: '', remarks: '' }); 
    } catch (err) {
      setStatus("Something went wrong, please try again.");
    }
  };

  return (
    <div className="w-full min-h-screen bg-gray-50 pb-20">
      <SubPageHeader title="Contact us" />
      
      <div className="container mx-auto px-4 py-16">
        <div className="flex flex-col lg:flex-row gap-12 max-w-6xl mx-auto">
          
          <div className="w-full lg:w-1/2 relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
              <img src={contactSideImage} alt="Contact" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#002147] to-transparent opacity-70"></div>
            </div>
            
            <div className="mt-8 space-y-6">
              <h3 className="text-2xl font-bold text-[#002147]">Let's Connect</h3>
              <div className="flex items-center gap-4 text-gray-600 hover:text-[#0056b3] transition-colors cursor-pointer">
                <FaWhatsapp className="text-2xl" />
                <span>+91 8080420434</span>
              </div>
              <div className="flex items-center gap-4 text-gray-600 hover:text-[#0056b3] transition-colors cursor-pointer">
                <FaEnvelope className="text-2xl" />
                <span>tgsoh91@gmail.com</span>
              </div>
            </div>
          </div>


          
          <div className="w-full lg:w-1/2 bg-white p-8 md:p-12 rounded-3xl shadow-lg border border-gray-100">
            <h2 className="text-4xl font-extrabold text-[#002147] mb-2">Get in Touch</h2>
            {status && <p className="mb-4 text-green-600 font-bold">{status}</p>} 
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <input 
                  type="text" placeholder="Your Name" required
                  className="w-full p-4 bg-gray-50 border-b-2 border-gray-200 focus:border-[#0056b3] outline-none"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
                <input 
                  type="email" placeholder="Email Address" required
                  className="w-full p-4 bg-gray-50 border-b-2 border-gray-200 focus:border-[#0056b3] outline-none"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>
              <textarea 
                rows="4" placeholder="Your Message..." required
                className="w-full p-4 bg-gray-50 border-b-2 border-gray-200 focus:border-[#0056b3] outline-none"
                value={formData.remarks}
                onChange={(e) => setFormData({...formData, remarks: e.target.value})}
              ></textarea>
              
              <button type="submit" className="w-full py-4 bg-[#002147] text-white font-bold uppercase hover:bg-[#54a50f] transition-all rounded-xl">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;